<template>
	<div class="title-top">
		<span class="list">{{$t('final[0]')}}</span>
	</div>
</template>

<script type="text/ecmascript-6">
export default {
	computed: {
	}
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	.title-top
		width: 80%
		margin: 40px auto
		border-bottom: 1px solid $color-theme
		.list
			font-size: $font-web-medium
			color: $color-theme
		.enlist
			font-size: $font-web-medium-s
</style>



// WEBPACK FOOTER //
// src/common/title-top/title-top.vue